import {AES, enc, mode, pad} from 'crypto-js';

const l = enc.Utf8.parse('sWJH4Vo96YcdbIwjt0DlnaSuK8Guzjnx');
const p = enc.Utf8.parse('0mCvrWL06fhVSfn5');


const uuid = function () {
  const arr = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
  let t = '';
  for (let a = 0; a < 32; a++) {
    let o = Math.round(61 * Math.random());
    t += arr[o]
  }
  return t
}

export const getEncryptParam = function (title: string) {
  const _uuid = uuid();
  const data = JSON.stringify({
    title,
    uuid: _uuid,
    subTitle: '',
    industryId: 15,
    desc: '设计',
    coreWordId: '',
    firstWordExtend: '',
    secondWordExtend: '',
    thirdWordExtend: '',
    fourthWordExtend: '',
    terminalType: 1,
    showRuleId: 0,
    productType: 11,
    channel: '',
    version: '',
    page: 1
  });
  const encrypt = AES.encrypt(data, l, {
    mode: mode.CBC,
    padding: pad.Pkcs7,
    iv: p
  })

  return {
    password: encrypt.ciphertext.toString(enc.Base64),
    uuid: _uuid,
    title
  }
}

function dataURLtoBlob(dataUrl: any) {
  let arr = dataUrl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bStr = atob(arr[1]),
    n = bStr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bStr.charCodeAt(n);
  }
  return new Blob([u8arr], {type: mime});
}

function blobToFile(theBlob: any, fileName: string) {
  theBlob.lastModifiedDate = new Date();
  theBlob.name = fileName;
  return theBlob;
}


export function base64ToFile(base64: string) {
  const blob = dataURLtoBlob(base64);
  return blobToFile(blob, 'file');
}
